import { createFocusTrap as d } from "focus-trap";
import { watch as p, unref as c, onUnmounted as k } from "vue";
import m from "lodash/isFunction";
import { keyCodes as s } from "./utils.js";
const F = {
  escapeDeactivates: !1,
  returnFocusOnDeactivate: !0,
  allowOutsideClick: !1,
  clickOutsideDeactivates: !0,
  initialFocus: void 0,
  fallbackFocus: void 0,
  preventScroll: !1,
  delayInitialFocus: !0,
  tabbableOptions: () => ({}),
  isKeyForward: (e) => e.keyCode === s.tab && !e.shiftKey,
  isKeyBackward: (e) => e.keyCode === s.tab && e.shiftKey
};
function C(e, l = !0, u = {}) {
  let t;
  const r = () => {
    t && t.activate();
  }, o = () => {
    t && t.deactivate();
  };
  p(
    l,
    (n) => {
      const i = c(e);
      if (i)
        if (n) {
          const a = { ...F, ...c(u) };
          t = d(i, {
            ...a,
            allowOutsideClick: (f) => m(a.allowOutsideClick) ? a.allowOutsideClick(f) : a.allowOutsideClick,
            fallbackFocus: a.fallbackFocus || (() => i)
          }), r();
        } else
          o();
    },
    { immediate: !0 }
  ), k(() => {
    o();
  });
}
export {
  C as useFocusTrap
};
//# sourceMappingURL=use-focus-trap.js.map
